import { render, staticRenderFns } from "./ExpandableText.vue?vue&type=template&id=2b86305f&scoped=true&"
import script from "./ExpandableText.vue?vue&type=script&lang=js&"
export * from "./ExpandableText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableText.vue?vue&type=style&index=0&id=2b86305f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86305f",
  null
  
)

export default component.exports